<template>
  <div class="player-area">
    <div class="outer-wrapper">
      <div class="player-bg" aria-hidden="true" :style="`background-image: url(${convertBlurImage(posterImage)}`">플레이어 배경 영역</div>
      <div class="inner-wrapper">
        <div class="player" id="player">
          <div class="player-bg" aria-hidden="true" :style="`background-image: url(${convertBlurImage(posterImage)}`">플레이어 배경 영역</div>
          <img
            :src="getThumbnailImg"
            :alt="contentInfo.title"
            :class="`player-image ${currentSection}`">
          <div @click.prevent="clickPlayer" class="btn-play"><player class="play-btn"></player></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Meta from '@/components/meta/Meta'
import Player from '@/assets/svg/common/ic-player-play-l.svg'
import _ from 'lodash'
import { ATTR_BY_PLAYER_TYPE } from '@/common/player.const'
import { resizeThumbnail } from '@/common/image.filter'
import { getDomainWithPrefix } from '@/common/utils/common'

/**
 * 기존 모바일웹에서 사용하는 플레이어 영역 Component
 * 재생 시 App 실행
 * 차후 이 Component만 갈아끼기 위해 Apollo쪽과 형태를 맞춤
 */
export default {
  mixins: [Meta],
  name: 'GoAppPlayer',
  data () {
    return {
      isHorizontal: false
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      titleTemplate: '%s : 웨이브'
    }
  },
  props: {
    contentInfo: {
      type: Object
    },
    currentSection: {
      type: String
    },
    clickPlayer: {
      type: Function
    },
    goBack: {
      type: Function
    }
  },
  components: {
    Player
  },
  computed: {
    metaTitle () {
      return _.get(this.contentInfo, ATTR_BY_PLAYER_TYPE[this.currentSection].title, '프로그램 상세화면')
    },
    posterImage () {
      // poster image 우선순위 mo-)  1. 로고 포함된 시즌(무비 그룹) 가로 포스터 / 2. 로고가 포함된 시즌(무비 그룹) 세로 포스터
      const {
        season_horizontal_logoY_image: horizonPosterVOD = '',
        season_vertical_logoY_image: verticalPosterVOD = '',
        moviegroup_horizontal_logoY_image: horizonPosterMovie = '',
        moviegroup_vertical_logoY_image: verticalPosterMovie = ''
      } = this.contentInfo

      const { seasonposterimage: alternativePosterVOD = '' } = this.contentInfo
      const isMovie = (this.currentSection === 'movie')
      const posterMovie = horizonPosterMovie || verticalPosterMovie
      const posterVOD = horizonPosterVOD || verticalPosterVOD || alternativePosterVOD

      return isMovie ? posterMovie : posterVOD
    },
    getThumbnailImg () {
      const horizontal = { width: 540, height: 302 }
      const vertical = { width: 202, height: 302 }
      const width = (this.isHorizontal ? horizontal.width : vertical.width) * 2
      const height = (this.isHorizontal ? horizontal.height : vertical.height) * 2

      return resizeThumbnail(this.posterImage, { width: width, height: height, isSquare: false })
    }
  },
  created () {
    this.getPosterType()
  },
  methods: {
    convertBlurImage (image) {
      const width = 124
      const height = 72
      const blurImageAddress = `image.cdn.wavve.com/v1/thumbnails/image/${width}_${height}_b20_10`
      return getDomainWithPrefix(`https://${image.replace(/(img\.wavve\.com|img\.pooq\.co\.kr)/gi, blurImageAddress)}`)
    },
    getPosterType () {
      const { season_horizontal_logoY_image: horizonPosterVOD = '', moviegroup_horizontal_logoY_image: horizonPosterMovie = '' } = this.contentInfo
      this.isHorizontal = (horizonPosterVOD + horizonPosterMovie).length > 0
    }
  }
}
</script>
<style scoped>
header {
  width: 100%;
}
.play-container.chrome-fixed{
  position: fixed;
  height: 100vh;
  overflow: hidden;
}
.player {
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: #252525;
  top: 0;
  left: 0;
  padding-top: 56.25%;
  max-height: 210px;
}
.player::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.3);
}
.player-image {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  height: 100%;
}

.player-back-btn {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 36px;
  height: 36px;
  z-index: 100;
}
/*.play-btn {*/
/*  position: absolute;*/
/*  top: 50%;*/
/*  left: 50%;*/
/*  width: 36px;*/
/*  height: 36px;*/
/*  margin-left: -18px;*/
/*  margin-top: -18px;*/
/*  z-index: 30;*/
/*}*/

.play-event-container a{
  display: block;
}

.play-event-container a img{
  display: block;
  width: 100%;
  max-width: 375px;
  margin: 0 auto;
}

@media screen and (min-width: 768px){
  .player{
    position: sticky;
    top: 0;
    z-index: 10;
  }
}
</style>
